import styled from "styled-components";

export const VoucherCardFaceVoucherNameBox = styled.div`
  font-size: 1.3rem;
  ${({theme}) => theme.font.presets.bold};
  letter-spacing: 1px;
  text-transform: uppercase;
`